import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CustomSpinnerComponent } from '../../shared/components/custom-spinner/custom-spinner.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  customSpinnerComponent = CustomSpinnerComponent;
  @Input() defaultLanguage;
  @Input() federaleURL;
  logoPath = 'assets/icons/logo.svg';
  selectLanguage: boolean;
  selectedLanguage;
  welcome: string;
  checkForHeader: boolean = true;
  overlayNL: boolean = true;
  overlayFR: boolean = false;
  checkforPass:boolean ;
  loginuser : string ;
  

  constructor(private translate: TranslateService,private router : Router) {

   }

  ngOnInit(): void {
    var currentlang = sessionStorage.getItem("currentlang")
    this.switchLang(currentlang);
    if(sessionStorage.getItem("ShowForgotPass")=="true")
    {
      this.checkforPass= true;
      sessionStorage.setItem("ShowForgotPass","false");
    }
    else
    {
      this.checkforPass = false;
    }

  }

  changeLanguage() {

    if (this.translate.currentLang == 'FR') {
      this.defaultLanguage = "NL";
      this.overlayNL = true;
      this.overlayFR = false;
      sessionStorage.setItem("currentlang", "NL")
      sessionStorage.setItem("presentLang", "Even geduld, we zijn uw gegevens aan het laden");
      document.getElementById('languageDropdown').innerHTML = 'FR';
      (<HTMLImageElement>document.getElementById("langlogo")).src = 'assets/Logos/logo-NL.svg';
    } else {
      this.defaultLanguage = "FR";
      this.overlayNL = false;
      this.overlayFR = true;
      sessionStorage.setItem("currentlang", "FR")
      sessionStorage.setItem("presentLang", "Veuillez patienter  svp, nous chargeons vos données");
      document.getElementById('languageDropdown').innerHTML = 'NL';
      (<HTMLImageElement>document.getElementById("langlogo")).src = 'assets/Logos/logo-FR.svg';
    }
    this.switchLang(this.defaultLanguage);
  }
  onDisplayHeader(checkForHeader) {
    this.checkForHeader = checkForHeader;
  }
  switchLang(lang: string) {
    this.defaultLanguage = lang;
    this.translate.use(lang);
  }
    OnDisplayForgotPassword(checkforPass)
    {
       this.checkforPass = checkforPass;
       var currentlang = sessionStorage.getItem("currentlang")
       this.switchLang(currentlang);
       this.defaultLanguage = currentlang;
       sessionStorage.setItem("checktoReload", "true");
    }
    getUsername(username)
    {
  this.loginuser = username;
    }
  
}
